<script setup lang="ts">
  import ModalMessages from '../../Modais/ModalMessages.vue'
</script>
<template>
  <h1 v-text="translate.title"></h1>
  <h3 class="d-none d-md-block u-mb-md-3" v-text="translate.sunscribeTitle"></h3>
  <form @submit="onSubmit" @reset="onReset">
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        v-model="form.afiliado_company"
        :placeholder="translate.subscribeNameEnterprise"
        aria-describedby="NameEnterprise"
      />
    </div>
    <div class="row">
      <div class="col-lg-9 col-md-9 col-sm-12 col-12">
        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            v-model="form.afiliado_contact_name"
            :placeholder="translate.subscribeName"
            aria-describedby="Name"
          />
        </div>
      </div>
      <div class="col-lg-3 cl-md-3 col-sm-12 col-12 d-flex align-items-center justify-content-center">
        <div class="mb-3">
          <input v-model="form.afiliado_contact_gender" type="radio" value="1" :checked="true" />
          {{ translate.generM }}
          <input class="ms-3" v-model="form.afiliado_contact_gender" type="radio" value="2" />
          {{ translate.generF }}
        </div>
      </div>
    </div>

    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        v-model="form.afiliado_fone"
        :placeholder="translate.subscribeNumber"
        aria-describedby="Number"
      />
    </div>
    <div class="mb-3">
      <input
        type="email"
        class="form-control"
        v-model="form.afiliado_email"
        id="input-email"
        :placeholder="translate.subscribeMail"
        aria-describedby="Email"
      />
    </div>
    <div class="mb-3">
      <input
        type="password"
        class="form-control"
        v-model="form.afiliado_password"
        :placeholder="translate.subscribePassword"
        aria-describedby="password"
      />
    </div>
    <div class="mb-3">
      <input
        type="password"
        class="form-control"
        v-model="form.afiliado_password_confirm"
        :placeholder="translate.subscribePasswordConfirm"
        aria-describedby="password confirm"
      />
    </div>
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        v-model="form.afiliado_site_url"
        :placeholder="translate.subscribeUrl"
        aria-describedby="website"
      />
    </div>
    <div class="row mt-5">
      <div class="col-12 div-terms">
        <legend>{{ translate.titleTermsUse }}</legend>
        <div class="col-12 box-terms">
          <span v-html="translate.terms"></span>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-lg-6 col-12 accept">
              <input type="checkbox" name="afiliado_accept_terms" id="acept" v-model="form.afiliado_accept_terms" />
              <label for="checkbox">{{ translate.aceitlabel }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center py-3 mt-5">
      <button class="d-w-btn" type="submit">
        {{ translate.subscribeButton }} <i class="icon-arrow-right"></i>
      </button>
    </div>
    <br /><br /><br />
  </form>
  <ModalMessages @showModalMessages="showModalMessages" :options="options" />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import api from '../../../api'
  import { localeStore } from 'stores/locale'
  import { mapState } from 'pinia'
  import tradutor from 'tradutors/afiliados'

  export default defineComponent({
    name: 'FaqSugestion',
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return tradutor.portugues
        } else {
          return tradutor.ingles
        }
      }
    },
    data() {
      return {
        form: {
          afiliado_company: '',
          afiliado_contact_name: '',
          afiliado_fone: '',
          afiliado_email: '',
          afiliado_password: '',
          afiliado_password_confirm: '',
          afiliado_site_url: '',
          afiliado_accept_terms: false,
          afiliado_contact_gender: ''
        },
        options: {
          showModal: false,
          titleModal: '',
          textBodyModal: '',
          textButtonModal: ''
        }
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        api
          .post('v1/subscribe/storeCreateAffiliates', this.form)
          .then(({ data }) => {
            if (data.message == 'success') {
              data.message = this.translate.msgSuccess
              this.onReset()
            }
            this.showModalMessages({
              message: {
                show: true,
                title: this.translate.msgTitle2,
                textButton: this.translate.msgClose,
                textBoby: data.message
              }
            })
          })
          .catch(() => {
            this.showModalMessages({
              message: {
                show: true,
                title: this.translate.msgTitle1,
                textButton: this.translate.msgClose,
                textBoby: this.translate.failSend
              }
            })
          })
      },
      showModalMessages(data) {
        this.options.showModal = data.message.show
        this.options.titleModal = data.message.title
        this.options.textBodyModal = data.message.textBoby
        this.options.textButtonModal = data.message.textButton
      },
      onReset(event) {
        event.preventDefault()
        // Reset our form values
        this.form = {
          afiliado_company: '',
          afiliado_contact_name: '',
          afiliado_fone: '',
          afiliado_email: '',
          afiliado_password: '',
          afiliado_password_confirm: '',
          afiliado_site_url: '',
          afiliado_accept_terms: false,
          afiliado_contact_gender: ''
        }
      }
    }
  })
</script>

<style lang="css" scoped>
  h3 {
    font-size: medium;
    font-family: 'Exo-2';
    color: black;
  }

  .form-control {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
    color: #747474;
    margin: 8px 5px;
    padding: 10px;
    font-size: 14px;
    border-radius: 30px;
  }

  legend {
    color: #b40909;
    font-weight: 700;
    font-family: 'Exo-2';
    margin-bottom: 30px;
    margin-left: 10px;
}

.d-w-btn {
    color: #fff;
    width: 100%;
    padding: 17px 0px;
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    font-family: 'Exo-2';
}

label {
    height: 23px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 23px;

}

input[type=checkbox] {
    position: relative;
    cursor: pointer;
    margin-inline: 15px;
    width: 20px;
    height: 20px;
}

input[type=checkbox]:before {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    top: -3px;
    left: -3px;
    background-color: #000;
}

input[type=checkbox]:checked:before {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    top: -3px;
    left: -3px;
    background-color: #000;
}

input[type=checkbox]:checked:after {
    content: "";
    display: block;
    width: 9px;
    height: 15px;
    border: solid red;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 2px;
    left: 6px;
}

.box-terms {
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    height: 400px;
    overflow-y: scroll;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-terms {
        width: 95%;
        margin-left: 10px;
    }

    legend {
        font-size: 18px;
    }

    .accept {
        margin-bottom: 30px;
    }

    .d-w-btn {
        width: 70%;
    }
}
</style>
